/* ================================================================
   Ninho Bebê — Wishlist (substitui Swym)
   localStorage-backed, cross-tab sync, página de favoritos via fetch.
   ================================================================ */

(() => {
  const KEY = 'lt_wishlist_v1';
  const read  = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (_) { return []; } };
  const write = (a) => localStorage.setItem(KEY, JSON.stringify(a));

  window.LtWishlist = {
    list: read,
    has: (h) => read().includes(h),
    toggle(h) {
      const list = read();
      const i = list.indexOf(h);
      if (i === -1) { list.push(h); write(list); return true; }
      list.splice(i, 1); write(list); return false;
    },
    count: () => read().length
  };

  function paint() {
    const list = read();
    document.querySelectorAll('[data-lt-wishlist]').forEach(btn => {
      btn.classList.toggle('is-active', list.includes(btn.dataset.ltWishlist));
    });
    document.querySelectorAll('[data-lt-wishlist-count]').forEach(el => {
      el.textContent = list.length;
      el.style.display = list.length > 0 ? '' : 'none';
    });
  }

  document.addEventListener('DOMContentLoaded', paint);
  window.addEventListener('storage', e => { if (e.key === KEY) paint(); });

  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-lt-wishlist]');
    if (!btn) return;
    e.preventDefault();
    LtWishlist.toggle(btn.dataset.ltWishlist);
    paint();
  });

  // Auto-attach wishlist heart to all product cards (Dawn .card-wrapper)
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.card-wrapper, .grid__item .card, .product-card-wrapper').forEach(card => {
      if (card.querySelector('[data-lt-wishlist]')) return;
      const link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      const handle = (link.getAttribute('href').split('/products/')[1] || '').split('?')[0].split('#')[0];
      if (!handle) return;
      const btn = document.createElement('button');
      btn.className = 'lt-wishlist-btn';
      btn.setAttribute('data-lt-wishlist', handle);
      btn.setAttribute('aria-label', 'Salvar nos favoritos');
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
      const wrapper = card.querySelector('.card__media') || card;
      const cs = getComputedStyle(wrapper);
      if (cs.position === 'static') wrapper.style.position = 'relative';
      wrapper.appendChild(btn);
    });
    paint();
  });

  // Wishlist page renderer (used by template /pages/favoritos)
  document.addEventListener('DOMContentLoaded', async () => {
    const root = document.querySelector('[data-lt-wishlist-root]');
    if (!root) return;
    const handles = read();
    if (!handles.length) {
      root.innerHTML = '<p style="text-align:center;padding:40px;color:#666;">Sua lista de favoritos está vazia. Toque no coração em qualquer produto pra salvar.</p>';
      return;
    }
    const html = await Promise.all(handles.map(async (h) => {
      try {
        const p = await fetch(`/products/${h}.js`).then(r => r.ok ? r.json() : null);
        if (!p) return '';
        const price = (p.price / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        return `
          <a class="card-wrapper" href="/products/${p.handle}" style="display:block;text-decoration:none;color:inherit;">
            <div style="aspect-ratio:1;border-radius:14px;overflow:hidden;margin-bottom:8px;position:relative;">
              <img src="${p.featured_image}" alt="${p.title}" style="width:100%;height:100%;object-fit:cover;">
              <button class="lt-wishlist-btn is-active" data-lt-wishlist="${p.handle}" aria-label="Remover">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
              </button>
            </div>
            <div style="font-size:14px;font-weight:500;margin-bottom:4px;">${p.title}</div>
            <div style="font-size:14px;font-weight:700;color:#006375;">${price}</div>
          </a>`;
      } catch (_) { return ''; }
    }));
    root.innerHTML = `<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:24px;">${html.join('')}</div>`;
  });
})();
